/*@ngInject*/
const CopySubmissionRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.copySubmission = function (submissionId, copyOptions) {
        const url = `/rest/Submission/${submissionId}/copySubmission`,
            config = {
                params: {
                    copyOptions: copyOptions
                }
            };

        return this.post(url, {}, config);
    };
};

angular.module('gw-um-submission')
    .service('copySubmissionRepository', CopySubmissionRepository);
